import { getI18n } from 'react-i18next';
import Logger from '~/utils/logger/logger';
import { InternationalizationNameSpace } from '~/constants/internationalization-namespace';
import { fallbackLng } from '~/config/i18n/languages';

export const formatMessageWrapper = (translationKey: string, values?: any) => {
  if (!translationKey || typeof translationKey !== 'string') {
    Logger.trace(
      'Tried to use FormatMessageWrapper with an erronous translationKey:',
      translationKey
    );
    return '';
  }

  const intl = getI18n();
  const primaryLanguage = intl.language.split('-')[0];
  const primaryTranslation = intl.getResource(
    primaryLanguage,
    InternationalizationNameSpace.Legacy,
    translationKey,
    values
  );

  if (primaryTranslation !== undefined) {
    return intl.t(primaryTranslation, values) as string;
  }

  const fallbackTranslation = intl.getResource(
    fallbackLng,
    InternationalizationNameSpace.Legacy,
    translationKey,
    values
  );
  if (fallbackTranslation !== undefined) {
    return intl.t(fallbackTranslation, values) as string;
  }

  return translationKey;
};

export default formatMessageWrapper;
